import { InfoboxFormValues, InfoboxPeriod } from './types'

export interface EffectiveFlags {
  showGrowth: boolean
  showDiff: boolean
  showCombo: boolean
  showComboGrowth: boolean
  showComboDiff: boolean
  showSparkline: boolean
}

const isYtd = (period: InfoboxPeriod | undefined): boolean => period === 'yeartodate' || period === 'fiscalyeartodate'

export function resolveEffectiveFlags(form: Partial<InfoboxFormValues>): EffectiveFlags {
  const hasComparison = form.comparison !== undefined && form.comparison !== 'none'
  const effectiveShowCombo = (form.showCombo ?? false) && isYtd(form.period) && hasComparison

  return {
    showGrowth: (form.showGrowth ?? false) && hasComparison,
    showDiff: (form.showDiff ?? false) && hasComparison,
    showCombo: effectiveShowCombo,
    showComboGrowth: (form.showComboGrowth ?? false) && effectiveShowCombo,
    showComboDiff: (form.showComboDiff ?? false) && effectiveShowCombo,
    showSparkline: form.showSparkline ?? false
  }
}

type FlagKey = keyof EffectiveFlags

export function resolveDisabledFlags(form: Partial<InfoboxFormValues>): Record<FlagKey, boolean> {
  const keys: FlagKey[] = ['showGrowth', 'showDiff', 'showCombo', 'showComboGrowth', 'showComboDiff', 'showSparkline']
  const result = {} as Record<FlagKey, boolean>
  for (const key of keys) {
    const test = { ...form, [key]: true }
    if (key === 'showComboGrowth' || key === 'showComboDiff') {
      test.showCombo = true
    }
    result[key] = !resolveEffectiveFlags(test)[key]
  }
  return result
}
